import React, { useState } from "react";
// componentes
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Input,
  Button,
} from "reactstrap";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// redux
import { connect } from "react-redux";
// service
import { newFeed } from "../../../utils/services/feed";
import { getUrlFiles } from "../../../utils/services/files";

function NewFeed(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  // dados do form
  const [texto, setTexto] = useState("");
  const [image, setImage] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  //confirmação
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  const [imageErro, setImageErro] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // valida o form, envia a imagem (se houver) e cria o post
  async function submitForm(e) {
    e.preventDefault();

    if (!texto && !image) {
      setImageErro("Selecione um texto ou uma imagem.");
      return;
    } else setImageErro("");

    let urlImg = "";
    let expireDate = null;

    if (image) {
      const data = new FormData();
      data.append("files", image.files[0]);
      data.append("folder", "feed");
      data.append("eventId", props.idEvent);

      try {
        const response = await getUrlFiles(
          data,
          props.state.global_user_data.data.token,
        );
        response.forEach((file) => {
          urlImg = file.url;
          expireDate = file.expires;
        });
      } catch (error) {
        console.error("Erro ao enviar a imagem:", error);
        setSubmitErrorMessage("Erro ao enviar a imagem.");
        return;
      }
    }

    const dataPost = {
      eventid: props.idEvent,
      title: "",
      text: texto,
      url: urlImg,
      active: isVisible,
      fixed: isFixed,
      date: new Date(),
      loginadmin_id: props.state.global_user_data.data.foundLogin.id,
      postsource: null,
      expireDate: expireDate,
    };

    setIsLoading(true);
    try {
      const feedData = await newFeed(
        dataPost,
        props.state.global_user_data.data.token,
      );
      if (feedData.message === "created") {
        setSuccessDlg(true);
      }
    } catch (error) {
      console.error("Erro ao criar o post:", error);
      setSubmitErrorMessage("Erro ao criar o post.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {successDlg ? (
        <SweetAlert
          success
          title={"Criado"}
          onConfirm={() => {
            props.getAllFeed();
            setSuccessDlg(false);
            toggle();
          }}
        >
          {"Post criado com sucesso!"}
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Novo Post</ModalHeader>
      <ModalBody>
        <form onSubmit={submitForm}>
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Texto</label>
                <textarea
                  className="form-control"
                  type="text"
                  value={texto}
                  onChange={(e) => setTexto(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Foto</label>
                <Input
                  className="form-control"
                  type="file"
                  id="formFile"
                  onChange={(e) =>
                    setImage(
                      e.target.files.length > 0
                        ? { files: e.target.files }
                        : null,
                    )
                  }
                />
                {imageErro && <span className="text-danger">{imageErro}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isVisible}
                  onChange={(e) => setIsVisible(e.target.checked)}
                />
                <label>Visível</label>
              </div>
            </Col>

            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isFixed}
                  onChange={(e) => setIsFixed(e.target.checked)}
                />
                <label>Fixado</label>
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewFeed);
